import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import heroImage from '../../assets/hero.png';

export default function ComingSoonPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-16">
        <section
          className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('${heroImage}')`,
            backgroundPosition: 'center 20%',
          }}
        >
          <div className="px-6 w-full">
            <div className="max-w-3xl mx-auto text-center text-white">
              <h1 className="text-5xl md:text-7xl font-bold tracking-wide">Comming Soon !</h1>
              <p className="mt-6 text-lg md:text-2xl text-gray-100 leading-relaxed">
                ただいま準備中です。公開まで今しばらくお待ちください。
              </p>
              <div className="mt-10 text-sm md:text-base text-gray-200">
                info@kushita-akimasa.com
              </div>
            </div>
          </div>

          <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/35" />
        </section>
      </main>

      <Footer />
    </div>
  );
}

